/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MdCommonModule, GestureConfig, StyleModule} from '../core';
import {MdSlider} from './slider';
import {RtlModule} from '../core/rtl/dir';
export class MdSliderModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule, MdCommonModule, StyleModule, RtlModule],
  exports: [MdSlider, MdCommonModule],
  declarations: [MdSlider],
  providers: [{provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSliderModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSliderModule.ctorParameters;
}



export {MD_SLIDER_VALUE_ACCESSOR,MdSliderChange,MdSliderBase,_MdSliderMixinBase,MdSlider,SliderRenderer} from './slider';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
